import { ApiService} from "@/libs";
import {DataService} from '@/service';

export class ClueService {

  // 创建一个线索
  static async clueCreate(clue: any) {
    const res = await DataService.post(`${ApiService.EngineerApi}/clue/create`, {
      compName: clue.compName,
      province: clue.province,
      city: clue.city,
      district: clue.district,
      products: clue.products,
      userName: clue.userName,
      phone: clue.phone,
      position: clue.position,
    });
    return res;
  }
}